import noop from "lodash/noop";
import config from "@config";

const ARC_BASENAME = '/mundial-2026/prode';
const basename = window.location.pathname.startsWith(ARC_BASENAME)
  ? ARC_BASENAME
  : (config.basePath || noop());

export default {
  basename,
  onBeforeChange: (dispatch, getState, { action }) => {},
  onAfterChange: (dispatch, getState, { action }) => {},
};
